const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/manage-contact-details/api-factory');
const serviceFactory = require('../resources/manage-contact-details/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/contactdetailsservice/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';
  return app => app
    .match(`${p}hrmw.getBpData[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getBpData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}hrmw.getContactDetailsListData[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getContactDetailsListData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}hrmw.saveForm[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.saveForm(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}hrmw.saveContactDetails[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.saveContactDetails(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}hrmw.signContact[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.signContact(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
}

module.exports = addRoutes;